import type { AdType } from '@/modules/adv/types'

import type { HbBidderConfig, AdAuctionSource } from '../types'

const PLAYGAMA_PUBLISHER_IDS: Record<AdAuctionSource, string> = {
    portal: 'playgama-portal',
    export: 'playgama-partners-games',
    'ad-sdk': 'playgama-partners-ad-sdk',
    'msn-ad-sdk': 'msn',
    'wrap-ad-sdk': 'playgama-partners-wrap',
    native: 'playgama-app',
}

const PLAYGAMA_AD_UNITS: Partial<Record<AdType, string>> = {
    rewarded: 'rewarded',
    interstitial: 'interstitial',
    interstitial_preroll: 'interstitial',
    universal_banner_1: 'advanced_banner',
    universal_banner_short_1: 'advanced_banner',
    universal_banner_2: 'advanced_banner',
    video_banner: 'video_player',
}

const PLAYGAMA_FALLBACK_AD_UNITS: Partial<Record<AdType, string>> = {
    rewarded: 'rewarded_fallback',
    interstitial: 'interstitial_fallback',
    interstitial_preroll: 'interstitial_preroll_fallback',
    universal_banner_1: 'advanced_banner_fallback',
    universal_banner_short_1: 'advanced_banner_fallback',
    universal_banner_2: 'advanced_banner_fallback',
    video_banner: 'video_player_fallback',
}

const getBannerPlaygamaFallback = (placement: AdType) =>
    placement in PLAYGAMA_FALLBACK_AD_UNITS ? PLAYGAMA_FALLBACK_AD_UNITS[placement] : 'banner_fallback'

const getBannerPlaygama = (placement: AdType) =>
    placement in PLAYGAMA_AD_UNITS ? PLAYGAMA_AD_UNITS[placement] : 'banner'

const PLAYGAMA_BASE_PARAMS = {
    env: 'production',
    apiKey: 'portal-key-001',
}

export const PLAYGAMA: HbBidderConfig = {
    bidder: 'playgama',
    params: ({ placement, adSource, requestContext }) => ({
        ...PLAYGAMA_BASE_PARAMS,
        publisherId: PLAYGAMA_PUBLISHER_IDS[adSource],
        adUnitId: getBannerPlaygama(placement),
        adPlacement: requestContext?.targeting.ad_placement || placement,
    }),
}

export const PLAYGAMA_FALLBACK: HbBidderConfig = {
    bidder: 'playgama',
    params: ({ placement, adSource, requestContext }) => ({
        ...PLAYGAMA_BASE_PARAMS,
        publisherId: PLAYGAMA_PUBLISHER_IDS[adSource],
        adUnitId: getBannerPlaygamaFallback(placement),
        adPlacement: requestContext?.targeting.ad_placement || placement,
    }),
}
